import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input
} from 'reactstrap';

export default class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: ''
    };

    this.onChange = this.onChange.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }

  onChange(e) {
    this.setState({
      value: e.target.value.replace(/^\s+|\s+(?=\s$|\s)/g, '')
    });
  }

  onConfirm(e) {
    e.preventDefault();

    this.setState({
      value: ''
    });

    this.props.onConfirm(this.state.value.trim());
  }

  render() {
    let {
      children,
      labelText,
      headerText,
      onConfirm,
      toggle,
      valid = value => true,
      inputProps,
      ...otherProps
    } = this.props;
    let { value } = this.state;

    let isValid = valid(value);

    return (
      <Modal {...otherProps} toggle={toggle} backdrop keyboard autoFocus>
        <form className="modal-prompt" onSubmit={this.onConfirm}>
          {!!headerText && <ModalHeader toggle={toggle}>{headerText}</ModalHeader>}
          <ModalBody>
            <FormGroup className="col-sm-12">
              {children}
              {!!labelText && <Label>{labelText}</Label>}
              <Input
                {...inputProps}
                autoFocus={true}
                valid={isValid}
                value={value}
                onChange={this.onChange}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button disabled={!isValid} type="submit" color="success">
              Confirma
            </Button>
          </ModalFooter>
        </form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Prompt.js